export default "__VITE_ASSET__BmUnxvmX__"